"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollEffect = exports.useElementSize = exports.useWindowSize = exports.isTouchDevice = exports.isInStandaloneMode = exports.isChromeOnIos = exports.isIos = exports.isEdge = exports.isIe = exports.isBrowser = void 0;
var react_1 = require("react");
exports.isBrowser = typeof window === 'object';
// @ts-ignore documentMode not in default types, it is only used by IE
exports.isIe = exports.isBrowser && !!document.documentMode;
exports.isEdge = exports.isBrowser && window.navigator.userAgent.indexOf('Edge') > -1;
var isIos = function () { return exports.isBrowser && (/iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase())
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)); };
exports.isIos = isIos;
var isChromeOnIos = function () { return (0, exports.isIos)() && /CriOS/i.test(navigator.userAgent); };
exports.isChromeOnIos = isChromeOnIos;
var isInStandaloneMode = function () {
    var isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    // @ts-ignore navigator.standalone is only available on iOs Safari
    if (navigator.standalone || isStandalone) {
        return true; // 'standalone';
    }
    if (document.referrer.startsWith('android-app://')) {
        return true; // 'twa';
    }
    return false; // 'browser';
};
exports.isInStandaloneMode = isInStandaloneMode;
exports.isTouchDevice = exports.isBrowser && (('ontouchstart' in window)
    || (navigator.maxTouchPoints > 0)
    // @ts-ignore msMaxTouchPoints not in default types, it is only used by IE
    || (navigator.msMaxTouchPoints > 0));
var useWindowSize = function () {
    var _a = (0, react_1.useState)({
        width: undefined,
        height: undefined,
    }), windowSize = _a[0], setWindowSize = _a[1];
    (0, react_1.useEffect)(function () {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        window.addEventListener('resize', handleResize);
        handleResize();
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    return windowSize;
};
exports.useWindowSize = useWindowSize;
var useElementSize = function () {
    var _a = (0, react_1.useState)({
        width: undefined,
        height: undefined,
    }), elementSize = _a[0], setElementSize = _a[1];
    var elementRef = (0, react_1.useCallback)(function (node) {
        function handleResize() {
            if (node !== null) {
                setElementSize({
                    width: node.getBoundingClientRect().width,
                    height: node.getBoundingClientRect().height,
                });
            }
        }
        window.addEventListener('resize', handleResize);
        handleResize();
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    return { elementRef: elementRef, elementSize: elementSize };
};
exports.useElementSize = useElementSize;
var useScrollEffect = function (onScrollUp, onScrollDown) {
    var scrollY = (0, react_1.useRef)(0);
    (0, react_1.useEffect)(function () {
        scrollY.current = window.pageYOffset;
        var update = function () {
            var prevScrollY = scrollY.current;
            var currentScroll = window.pageYOffset;
            if (prevScrollY > currentScroll) {
                // console.log('scrolling up - show menu');
                onScrollUp();
            }
            else if (currentScroll > 0) {
                // Must check > 0 to account for "scroll to refresh" functionality (which sets Y-pos negative on iphone)
                // console.log('scrolling down - hide menu');
                onScrollDown();
            }
            scrollY.current = currentScroll;
        };
        window.addEventListener('scroll', update);
        return function () {
            window.removeEventListener('scroll', update);
        };
    }, [onScrollDown, onScrollUp]);
};
exports.useScrollEffect = useScrollEffect;
